import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import DashboardPage from "@/pages/DashboardPage";
import StationDetailPage from "@/pages/StationDetailPage";
import MapPage from "@/pages/MapPage";
import ComparePage from "@/pages/ComparePage";
import FavoritesPage from "@/pages/FavoritesPage";
import MeteocatPanelPage from "@/pages/MeteocatPanelPage";
import { InstallPrompt } from "@/components/InstallPrompt";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/station/:id" element={<StationDetailPage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/favorites" element={<FavoritesPage />} />
          <Route path="/panel/:token" element={<MeteocatPanelPage />} />
        </Routes>
      </Layout>
      <InstallPrompt />
      <Toaster
        theme="dark"
        richColors
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(15,15,20,0.9)",
            border: "1px solid rgba(124,58,237,0.35)",
            color: "white",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
